import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosApexInstance from '../auth/axiosApexInstance';
import { FavLinkSectionDTO } from '../types';
import { useUser } from './UserContext';

interface FavLinksContextType {
    favLinks: FavLinkSectionDTO[];
    setFavLinks: (sections: FavLinkSectionDTO[]) => void;
    refreshFavLinks: () => Promise<void>;
    saveFavLinks: () => Promise<void>;
}

const FavLinksContext = createContext<FavLinksContextType>({} as any);

export const FavLinksProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { apexUser } = useUser();
    const [favLinks, setFavLinks] = useState<FavLinkSectionDTO[]>([]);

    const refreshFavLinks = async () => {
        const res = await axiosApexInstance.get('/task/favlinks', {
            params: { userId: apexUser?.userId },
        });
        setFavLinks(res.data); // already includes id, userId, etc.
    };

    const saveFavLinks = async () => {
        const payload = favLinks.map((section, i) => ({
            ...section,
            sectionOrder: i,
            userId: section.userId ?? apexUser?.userId,
        }));

        await axiosApexInstance.post('/task/favlinks', payload, {
            params: { userId: apexUser?.userId },
        });
    };

    useEffect(() => {
        if (apexUser?.userId) refreshFavLinks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apexUser?.userId]);

    return (
        <FavLinksContext.Provider
            value={{ favLinks, setFavLinks, refreshFavLinks, saveFavLinks }}
        >
            {children}
        </FavLinksContext.Provider>
    );
};

export const useFavLinks = () => useContext(FavLinksContext);
